import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_URL } from '../constants/api-url';
import { TokenStorageService } from '../services/token-storage.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const tokens = inject(TokenStorageService);
  const token = tokens.getToken();
  const isBitrazeApi = request.url === API_URL || request.url.startsWith(`${API_URL}/`);
  return next(token && isBitrazeApi ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request);
};
